import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiListDataService } from './api.list-data.service';
import { ClientFilterLookup } from '../../models';

@Injectable({
    providedIn: 'root',
})
export class ApiClientFilterLookupService extends ApiListDataService<
    ClientFilterLookup,
    ClientFilterLookup
> {
    constructor(http: HttpClient) {
        super(http, '/Client/ClientFilterLookup/');
    }
}
